import borders from "assets/theme/base/borders";

const { borderRadius } = borders;

const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: "#fff",
      boxShadow: "none",
      borderRadius: borderRadius.lg,
      border: "1px solid #E8EDF2",
      overflow: "hidden",
    },
  },
};

export default tableContainer;
